import {Role, RoleMask} from "../models/UserModel";

export const hasRole = (mask?: RoleMask | null, role?: Role | null): boolean => {
    if (!mask || !role) return false;
    return (mask & role) !== 0;
}
